export class ConsentAdditionalData {
    customerTitle?: string;
    customerRisks?: string;
    otherObservations?: string;
    customerAlternatives?: string;
    procedureCie10?: string;
    diagnosticCie10?: string;
    additionalClause?: string;
}